{{#with attributes}}
<div class="control-bar-menu control-bar-menu-{{key}}" data-menu="{{key}}">
  <div>
    {{#if submenu}}
    <a role="button" tabindex="0" class="control-bar-menu__back-button" target="{{backButtonTarget}}" aria-label="{{t 'video.backToSettingsMenu'}}" data-action-target="ctl-bar-menu-back-btn">
      {{>icon uuid=(concat cid '-' key '-back-icon') icon='fas fa-chevron-circle-left'}}
    </a>
    {{/if}}
    <span class="control-bar-menu__title{{#unless submenu}} control-bar-menu__title--not-submenu{{/unless}}">{{title}}</span>
  </div> 
  <{{#if orderedList}}ol{{else}}ul{{/if}}{{#if hideInactiveBeforeIcons}} class="control-bar-menu--hide-inactive-before-icons"{{/if}}  role="menu">
  {{#each items}}
    <li role="presentation">
   <a {{#if submenu}} role="button" {{else}}role="menuitemradio" {{/if}} {{#if submenu}}  aria-expanded="{{#if active}}true{{else}}false{{/if}}"{{else}} aria-checked="{{#if active}}true{{else}}false{{/if}}" {{/if}} tabindex="0" {{#if target}} data-target="{{target}}"{{/if}}{{#if modalID}}{{#if actionTarget}} data-action-target="{{actionTarget}}"{{/if}}data-index={{@index}} data-open-modal="{{modalID}}"{{/if}}{{#if key includeZero="true"}} data-key="{{../key}}-{{../cid}}-{{key}}"{{/if}} class="control-bar-menu__item control-bar-menu__item-{{@index}}{{#if active}} control-bar-menu__item--active{{/if}}">
         {{#if before_icon}}
        <span role="presentation" class="control-bar-menu__item__before-icon control-bar-menu__item__before-icon-{{@index}}">
          {{>icon uuid=(concat ../cid '-' ../key '-' @index '-before-icon')
            icon=before_icon.icon
            classes=before_icon.classes
          }}
        </span>
        {{/if}}
        <span class="control-bar-menu__item__title">{{title}}</span>
        {{#if after_icon}}
        <span role="presentation" class="control-bar-menu__item__after-icon">
          {{>icon uuid=(concat ../cid '-' ../key '-' @index '-after-icon')
            icon=after_icon.icon
            classes=after_icon.classes
          }}
        </span>
        {{/if}}
      </a>
    </li>
  {{/each}}
  </{{#if orderedList}}ol{{else}}ul{{/if}}>
</div>
{{#each items}}
  {{#if target}}
    <div class="{{target}}"></div>
  {{/if}}
{{/each}}
{{/with}}
